const relative = (value) => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';

    const minutes = Math.floor((Date.now() - date.getTime()) / 60000);
    if (minutes < 1) return 'ahora';
    if (minutes < 60) return `${minutes} min`;
    if (minutes < 1440) return `${Math.floor(minutes / 60)} h`;
    return date.toLocaleDateString();
};

/**
 * Bandeja privada de la modelo.
 *
 * Cada entrada es una conversación con un cliente distinto; el punto de no
 * leídos es lo que le permite saber a quién le debe respuesta sin abrir los
 * hilos uno por uno.
 */
export default function ChatConversations({ conversations, activeThread, onSelect }) {
    if (!conversations.length) {
        return (
            <p className="chat-empty">
                Todavía no tienes conversaciones privadas.<br />
                Aparecerán aquí en cuanto alguien te escriba.
            </p>
        );
    }

    return (
        <div className="chat-conversations">
            {conversations.map((item) => (
                <button
                    type="button"
                    key={item.client_id}
                    className={`chat-conversation ${activeThread === item.client_id ? 'active' : ''}`}
                    onClick={() => onSelect(item.client_id)}
                >
                    <span className="chat-conversation-avatar">
                        {item.client_name?.[0]?.toUpperCase() || 'U'}
                    </span>
                    <span className="chat-conversation-body">
                        <span className="chat-conversation-top">
                            <strong>{item.client_name}</strong>
                            <span className="chat-conversation-time">{relative(item.last_at)}</span>
                        </span>
                        <span className="chat-conversation-preview">{item.last_message}</span>
                    </span>
                    {item.unread > 0 && (
                        <span className="chat-conversation-unread">{item.unread > 9 ? '9+' : item.unread}</span>
                    )}
                </button>
            ))}
        </div>
    );
}
